export type ListingHoverPopoverPlacement = {
  left: number
  side: 'above' | 'below'
  top: number
}

const POPOVER_GAP_PX = 10
const POPOVER_MARGIN_PX = 12

function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max)
}

export function getListingHoverPopoverPlacement({
  anchor,
  mapSize,
  popoverSize,
}: {
  anchor: { x: number; y: number }
  mapSize: { height: number; width: number }
  popoverSize: { height: number; width: number }
}): ListingHoverPopoverPlacement {
  const maxLeft = Math.max(POPOVER_MARGIN_PX, mapSize.width - popoverSize.width - POPOVER_MARGIN_PX)
  const maxTop = Math.max(POPOVER_MARGIN_PX, mapSize.height - popoverSize.height - POPOVER_MARGIN_PX)
  const spaceAbove = anchor.y - POPOVER_MARGIN_PX
  const side =
    spaceAbove >= popoverSize.height + POPOVER_GAP_PX ? 'above' : 'below'
  const preferredTop =
    side === 'above'
      ? anchor.y - popoverSize.height - POPOVER_GAP_PX
      : anchor.y + POPOVER_GAP_PX

  return {
    left: clamp(
      anchor.x - popoverSize.width / 2,
      POPOVER_MARGIN_PX,
      maxLeft
    ),
    side,
    top: clamp(preferredTop, POPOVER_MARGIN_PX, maxTop),
  }
}
